
import React from "react";
import styles from './MessageComp.module.css';

// external dep 
import { useNavigate } from "react-router-dom";
import { AiOutlineDelete } from "react-icons/ai";

const MessageComp = ({ heading, txt, date,time, deleteProps })=>{

    const navigateToMessageBodyContent = ()=>{
        navigate('mesage-content');
    };

    const navigate = useNavigate();

    
    return(<div className={styles.MessageComp_cont__}>
        
        <article className={styles.sub_header_dt_}>
            <h3 className={styles.hhh333___} onClick={navigateToMessageBodyContent}> 
                {/* <AiOutlineSave className={styles.sub_bsd_icon_}/>  */}
                &#160; 
                { heading }
            </h3>

            <p className={styles.ppppp_del_date_}>

                {date} {time} &nbsp;&nbsp; 

                <AiOutlineDelete 
                    className={styles.delete_icon__} 
                    title={'delete this notification'} 
                    onClick={()=> deleteProps()} 
                /> 

            </p>
        </article>

        <p className={styles.actual_msg_} onClick={navigateToMessageBodyContent}>{ txt }</p>
        
    </div>)
}

export default MessageComp;